import { useCallback, useContext, useEffect, useState } from "react";
import { SignFormContext } from "../../SignForm";
import api from "../../../../../../service/api";
import { getType } from "@reduxjs/toolkit";
import useStudentResource from "../../../../BcaAttendance/hooks/useStudentResource";
import handleSignatureSubmit from "./handleSignatureSubmit";
// import handleSignatureSubmit from "../../../../BcaAttendance/hooks/handleSignatureSubmit";

export default function useSignFormPayload() {
    const {
        batchData,
        studentDataArray,
        studentDropdownData,
        pdfTemplateDropdownData,
        pdfUrl,
        setPdfUrl,
        batch_student_id, setBatchStudentId,
        template_id, setTemplateId,
        payload,
        student_id, setStudentId,
        s3Link, setS3Link,
    } = useContext(SignFormContext) ?? {};
    // const [student_id, setStudentId] = useState(null);
    // const [payload, setPayload] = useState({
    //     template_id: null,
    //     batch_student_id: null
    // });

    const studentResource = useStudentResource({ id: null }) // student 
    const { handleSubmit, loadSignatures, requestRefresh, setRequestRefresh } = handleSignatureSubmit({ id: payload?.batch_student_id ?? null }); // need to change this to use the selected student data 

    const handleTemplateSelection = useCallback((selection) => {
        const value = !selection ? null : (selection.value != '' ? selection.value : null);
        setTemplateId(value);
    }, [setTemplateId]);

    const handleStudentSelection = useCallback((selection) => {
        const value = !selection ? null : (selection.value != '' ? selection.value : null);
        setBatchStudentId(value);
    }, [setBatchStudentId]);

    useEffect(() => {

        if (!batch_student_id || !template_id) {
            setS3Link(null);
        }

        if (batch_student_id) {
            // studentResource.fetchStudentData({id: batch_student_id});
            const student_data = studentDataArray.find((value) => value.id == batch_student_id);
            setStudentId(student_data?.student?.id ?? null);
        }

        if (template_id && batch_student_id) {
            fetchPdf();
            gets3PdfLink();
        }
    }, [template_id, batch_student_id]);

    useEffect(() => {
        if (requestRefresh) {
            fetchPdf();
            gets3PdfLink();
            setRequestRefresh(false);
        }
    }, [requestRefresh])

    const fetchPdf = async () => {
        try {
            const response = await api.getpdf(`tms/bca-forms/view-pdf/${payload.template_id}/${payload.batch_student_id}`, payload);
            const blob = new Blob([response], {type: 'application/pdf'}); //this make the magic
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
        } catch (error) {
            console.error('Error fetching PDF:', error);
        }
    };

    const gets3PdfLink = async () => {
        try {
            const response = await api.get(`tms/bca-forms/get-s3-file/${payload.template_id}/${payload.batch_student_id}`, payload);
            setS3Link(response?.data?.full_path ?? null);
        } catch (error) {
            console.error('Error fetching S3 file link', error);
        }
    }

    return {
        batchData,
        studentDataArray,
        pdfTemplateDropdownData,
        studentDropdownData,
        handleTemplateSelection,
        handleStudentSelection,
        ...studentResource,
        handleSubmit,
        loadSignatures,
        pdfUrl,
        batch_student_id, setBatchStudentId,
        template_id, setTemplateId,
        payload,
        batch_student_id,
        student_id,
        s3Link, setS3Link,
    };
}